import MUISwitch, { SwitchProps } from "@material-ui/core/Switch";
import React, { FC } from "react";
import { withStyles } from "@material-ui/core/styles";

const CustomSwitch = withStyles({
  switchBase: {
    color: "#FF724C",
    "&$checked": {
      color: "#FF724C",
    },
    "&$checked + $track": {
      backgroundColor: "#FF724C",
    },
  },
  checked: {},
  track: {},
})(MUISwitch);

const Switch: FC<SwitchProps> = (props) => {
  return <CustomSwitch {...props} />;
};

export default Switch;
